export default "__VITE_ASSET__d28e20a5__"